import React from 'react'
import PropTypes from 'prop-types'
import { StyledBox } from './styles'

const Callout = ({ text }) => {
  return <StyledBox role="callout">{text}</StyledBox>
}

Callout.propTypes = {
  text: PropTypes.string,
}

export default Callout
